var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "#2B43DA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91038 0.863206C9.30091 1.25373 9.30091 1.8869 8.91038 2.27742L3.61749 7.57031L8.91038 12.8632C9.30091 13.2537 9.30091 13.8869 8.91038 14.2774C8.51986 14.6679 7.88669 14.6679 7.49617 14.2774L0.789062 7.57031L7.49617 0.863206C7.88669 0.472681 8.51986 0.472681 8.91038 0.863206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrowLeft);
export default __webpack_public_path__ + "static/media/blue-arrow-left.29193f4a7b1c0b287f5956874ed4912c.svg";
export { ForwardRef as ReactComponent };